import type { ReactNode } from "react"
import { memo } from "react"
import { useNavigate } from "@tanstack/react-router"
import { IconSidebarEditFill18 as CustomizeIcon } from "nucleo-ui-fill-18"

import {
	ContextMenu,
	ContextMenuContent,
	ContextMenuItem,
	ContextMenuSeparator,
	ContextMenuTrigger,
} from "@productlane/ui"

import type { SidebarMoreEntry } from "./sidebar-more-item"
import { SIDEBAR_LAYOUT_COPY as copy } from "./copy"
import { useCustomizeSidebarState } from "./sidebar-layout-state"

/** Right-click anywhere in the sidebar: the hidden items, then the way into the customize dialog. */
export const SidebarContextMenu = memo(
	({
		hiddenItems,
		onNavClick,
		children,
	}: {
		hiddenItems: SidebarMoreEntry[]
		onNavClick?: () => void
		children: ReactNode
	}) => {
		const navigate = useNavigate()
		const setCustomizeOpen = useCustomizeSidebarState((state) => state.setOpen)

		return (
			<ContextMenu>
				<ContextMenuTrigger asChild>{children}</ContextMenuTrigger>
				<ContextMenuContent className="w-56" data-testid="sidebar-context-menu">
					{hiddenItems.map((item) => (
						<ContextMenuItem
							key={item.href}
							Icon={item.icon}
							onSelect={() => {
								onNavClick?.()
								void navigate({ href: item.href })
							}}
						>
							{item.title}
						</ContextMenuItem>
					))}
					{hiddenItems.length > 0 && <ContextMenuSeparator />}
					<ContextMenuItem
						Icon={CustomizeIcon}
						onSelect={() => setCustomizeOpen(true)}
					>
						{copy.dialogTitle}
					</ContextMenuItem>
				</ContextMenuContent>
			</ContextMenu>
		)
	},
)
